function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#ED2939",
  d: "M36 27a4 4 0 0 1-4 4h-8V5h8a4 4 0 0 1 4 4v18z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#002495",
  d: "M4 5a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h8V5H4z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#EEE",
  d: "M12 5h12v26H12z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 36 36",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/france.22e3b201.svg";
export { SvgComponent as ReactComponent };